__turbopack_context__.v({
  "checkbox-container": "ce2ATq_checkbox-container",
  "checked": "ce2ATq_checked",
  "color-label-checkbox": "ce2ATq_color-label-checkbox",
  "count": "ce2ATq_count",
  "filter-item": "ce2ATq_filter-item",
  "filter-more-link": "ce2ATq_filter-more-link",
  "group-color-container": "ce2ATq_group-color-container",
  "item-sub-cat": "ce2ATq_item-sub-cat",
  "label-checkbox": "ce2ATq_label-checkbox",
  "root-checkbox": "ce2ATq_root-checkbox",
});
